import { z } from 'zod'

export const errorResponseSchema = z.object({
  success: z.literal(0),
  data: z.object({
    code: z.number().int(),
  }),
})
